import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { useState, useRef, useEffect } from "react";

import { useAlert } from "../../../../../contexts/alert-context";
import { EmailsWarningDTO } from "../models/emails-warning-DTO";
import { addNew, getEmailWarningById } from "../emails-warning-service";


interface ModalProps {
  onClose: () => void;
  userId: string;
}

const EmailsWarningForm: React.FC<ModalProps> = ({ onClose, userId }) => {
  const { t } = useTranslation();

  const { id } = useParams<{ id: string }>();
  const { setAlert } = useAlert();
  const [user, setUser] = useState<EmailsWarningDTO | null>(null);
  const currentURL = window.location.href;

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<EmailsWarningDTO>();

  const phoneRef = useRef(null);

  useEffect(() => {
    if (userId) {
      getEmailWarningById(userId).then((data) => {
        if (data) {
          setUser(data);
          Object.entries(data).forEach(([key, value]) => {
            if (typeof value === "object" && value !== null) {
              Object.entries(value as Record<string, unknown>).forEach(
                ([subKey, subValue]) => {
                  setValue(
                    `${key}.${subKey}` as keyof EmailsWarningDTO,
                    subValue as any
                  );
                }
              );
            } else {
              setValue(key as keyof EmailsWarningDTO, value as any);
            }
          });
        }
      });
    }
  }, [userId, setValue]);

  const onSubmit = async (emailWarning: EmailsWarningDTO) => {
    try {
      if (id) {
        await addNew(emailWarning, id);
        setAlert({ text: t("alert-successfully-registered"), type: "success" });
        onClose();
      }
    } catch (e) {
      console.error("Erro ao cadastrar: ", e);
      setAlert({ text: `${t("alert-error-registered")}:`, type: "error" });
    }
  };

  return (
    <div className="modal-content">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form-fields flex-column">
          <h2>{t("label-email-warning")}</h2>

          <div className="flex-column">
            <label htmlFor="legalName">{`${t("label-name")}*`}</label>
            <input
              placeholder={t("placeholder.generalEmpty")}
              type="text"
              id="legalName"
              {...register("userInfo.name", { required: true })}
            />
            {errors.userInfo?.name && <span>{t("error-input-required")}</span>}
          </div>

          <div className="flex-column">
            <label htmlFor="tradingName">{`${t("label-email")}*`}</label>
            <input
              placeholder={t("placeholder.email")}
              type="text"
              id="tradingName"
              {...register("userInfo.email", { required: true })}
            />
            {errors.userInfo?.email && <span>{t("error-input-required")}</span>}
          </div>
        </div>
        <br />
        <hr />
        <br />

        <div className="form-fields flex-column">
          <div className="flex-column">
            <label htmlFor="observations">
              {t("label-general-observations")}
            </label>
            <textarea
              placeholder={t("placeholder.observations")}
              id="observations"
              {...register("observations.observations")}
            />
          </div>
        </div>

        <div className="flex-row buttons-section">
          <button className="neutral-white" onClick={onClose} type="button">
            {t("label-back")}
          </button>
          <button className="blue" type="submit">
            {t("label-save")}
          </button>
        </div>
      </form>
    </div>
  );
};

export default EmailsWarningForm;
